import React from 'react';
import { connect } from 'react-redux';
import { IDispatchProp } from 'restdux';
import {
    Button,
    Collapse,
    Divider,
    IconButton,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    Menu,
    MenuItem,
    Paper,
    Theme,
    Typography,
    withTheme, 
    WithTheme 
} from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { createStyles, withStyles, WithStyles } from '@material-ui/styles';
import AvailabilityBlockDeleteModal from './DeleteModal';
import AvailabilityBlockEditModal from './AddEditModal';
import { IReturn as BlockedTime, actions as blockedTimeActions } from '../../../api/resources/BlockedTime';
import moment from 'moment';
import Moment from 'react-moment';

const styles = (theme: Theme) =>
    createStyles({
        content: {
            padding: '8px 16px',
        },
        itemActions: {
            display: 'flex',
            justifyContent: 'flex-end',
        }
    });

interface IProps {
    index: number;
    block: BlockedTime;
};

interface IState {
    anchorEl?: React.ReactNode;
    expanded: boolean;
    showChangeModal: boolean;
    showDeleteModal: boolean;
    showEditModal: boolean;
}

type FullProps = IProps & WithStyles<typeof styles> & WithTheme & IDispatchProp;
class AvailabilityBlockItem extends React.PureComponent<FullProps, IState> {
    public state = {
        anchorEl: null,
        expanded: false,
        showChangeModal: false,
        showDeleteModal: false,
        showEditModal: false,
    }
    
    render() {
        const { index, block, classes } = this.props;
        const { anchorEl, expanded, showChangeModal, showDeleteModal, showEditModal } = this.state;

        return (
            <React.Fragment>
                {index != 0 && (
                <Divider component="li" />
                )}
                <ListItem>
                    <ListItemText primary={moment(block.start_datetime).format('L')} />
                    <ListItemText secondary={(
                        <>
                            <Moment format='LT'>{block.start_datetime}</Moment> - <Moment format='LT'>{block.end_datetime}</Moment>
                        </>
                    )} />
                    <ListItemSecondaryAction>
                        <IconButton onClick={this.handleExpandMenu}>
                            <MoreVert />
                        </IconButton>
                    </ListItemSecondaryAction>
                </ListItem>
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={expanded}
                    onClose={this.handleCloseMenu}
                >
                    <MenuItem onClick={this.handleEditClick}>Edit</MenuItem>
                    <Divider />
                    <MenuItem onClick={this.handleDeleteClick}>Delete</MenuItem>
                </Menu>
                <AvailabilityBlockDeleteModal open={showDeleteModal} onDismiss={this.handleDeleteDismiss} />
                <AvailabilityBlockEditModal block={block} open={showEditModal} onDismiss={this.handleEditDismiss} />
            </React.Fragment>
        )
    }

    private handleExpandMenu = (event: React.MouseEvent) => {
        this.setState({
            anchorEl: event.target, 
            expanded: true
        });
    }

    private handleCloseMenu = () => {
        this.setState({expanded: false});
    }

    private handleDeleteClick = () => {
        this.setState({
            expanded: false, 
            showDeleteModal: true
        });
    }

    private handleDeleteDismiss = (shouldDelete: boolean) => {
        if (shouldDelete) {
            const { block, dispatch } = this.props;
            dispatch(blockedTimeActions.delete(block.id)).catch(console.error);
        }
        this.setState({showDeleteModal: false});
    }

    private handleEditClick = () => {
        this.setState({
            expanded: false,
            showEditModal: true
        });
    }

    private handleEditDismiss = (shouldRefresh: boolean) => {
        this.setState({showEditModal: false});
    }
}

export default connect()(withTheme(withStyles(styles)(AvailabilityBlockItem)));